"use client";

import styles from "./styles/text-to-music-page.module.scss";
import LengthSlider from "@/components/pages/text-to-music/components/length-slider";
import GenerateMusicButton from "@/components/pages/text-to-music/components/generate-music-button";
import TextToAudioInput from "@/components/pages/text-to-music/components/text-to-audio-input";
import ProgressBar from "@/components/pages/convert/components/progress-bar";
import React, { useEffect, useState } from "react";
import { useTextToMusicProgressContext } from "@/components/pages/text-to-music/components/providers/text-to-music-progress-provider";
import { useCancelTextToMusic } from "@/components/pages/text-to-music/hooks/use-cancel-text-to-music";
import StemResultItem from "@/components/pages/stem-splitter/components/stem-result-item";
import Suggestions from "@/components/pages/text-to-music/components/suggestions";
import ServicePageHeader from "@/components/common/service-page-header";
import { useTextToMusicContext } from "@/components/pages/text-to-music/components/providers/text-to-music-provider";
import {
  shouldDisplayProgress,
  shouldDisplayStartProcessButton,
} from "@/hooks/progress-context/use-anonymous-progress-provider";

const TextToMusicPage = () => {
  const progressContext = useTextToMusicProgressContext();
  const { settings, handleTextChange } = useTextToMusicContext();
  const { cancelTextToMusic, isCancelling } = useCancelTextToMusic();
  const [result, setResult] = useState<string>();

  const getFile = async (fileName: string) => {
    const resp = await fetch(
      "/api/text-to-music/get?" +
        new URLSearchParams({
          fileName: fileName,
        }),
    );
    if (resp.status === 200) {
      return await resp.text();
    }
    return undefined;
  };

  useEffect(() => {
    const fetchResults = async () => {
      const res = await getFile(progressContext.result);
      setResult(res);
    };

    if (progressContext.status === "complete") {
      fetchResults();
    }
  }, [progressContext.status, progressContext.result]);

  return (
    <div className={styles.page_wrapper}>
      <ServicePageHeader
        title={
          <>
            AI Text <span> To</span> Song
          </>
        }
        description={"One-Click AI Singer Generator"}
      />
      <div className={styles.input_wrapper}>
        <div className={styles.text_input_header}>
          <p className={styles.describe_text}>
            Describe the music you want to generate
          </p>
          <p className={styles.instrumental_text}>Instrumentals only</p>
        </div>
        <TextToAudioInput
          settings={settings}
          handleTextChange={handleTextChange}
          placeholder={
            "Generate a calm, acoustic guitar piece, reminiscent of a quiet evening, with soft strumming patterns and a slow, soothing rhythm"
          }
          maxLength={500}
        />
      </div>
      <Suggestions />
      <LengthSlider />

      {shouldDisplayStartProcessButton(progressContext.status) && (
        <GenerateMusicButton />
      )}

      {shouldDisplayProgress(progressContext.status) && (
        <ProgressBar
          percent={progressContext.percent}
          descriptionCode={progressContext.description}
          onCancel={cancelTextToMusic}
          isCancelling={isCancelling}
        />
      )}

      {progressContext.status === "complete" && (
        <div className={styles.results}>
          <p>{progressContext.result}</p>
          <StemResultItem url={result!} stem={"Result"} />
        </div>
      )}
    </div>
  );
};

export default TextToMusicPage;
